import { useMutation } from '@tanstack/react-query';

import { saveHsptlzFormCcrc } from '../api';

export const useSaveHsptlzFormCcrc = () => {
  const { mutate, data, isSuccess } = useMutation({
    mutationKey: ['saveHsptlzFormCcrc'],
    mutationFn: ({ params, navigate }) => {
      return saveHsptlzFormCcrc(params, navigate);
    },
  });

  return { mutate, data, isSuccess };
};
